<div class="profile-page">
    <div class="profile-card">
      <h2>User Profile</h2>
      <p>Manage your account details</p>
  
      <form #userForm="ngForm">
        <div class="form-container">
          <!-- Two fields in one row -->
          <div class="form-row">
            <!-- User ID (Disabled) -->
            <mat-form-field appearance="outline" class="half-width">
              <mat-label>User ID</mat-label>
              <input matInput [(ngModel)]="userdata.userName" name="userName" required #userName="ngModel" disabled>
            </mat-form-field>
   <!-- Email -->
   <mat-form-field appearance="outline" class="half-width">
    <mat-label>Email</mat-label>
    <input matInput [(ngModel)]="userdata.emailAddress" name="emailAddress" required email #emailAddress="ngModel">
    <mat-error *ngIf="emailAddress.invalid && emailAddress.touched">
      <span *ngIf="emailAddress.errors?.required">Email is required</span>
      <span *ngIf="emailAddress.errors?.email">Invalid email address</span>
    </mat-error>
  </mat-form-field>
           
          </div>
  
          <div class="form-row">
             <!-- First Name -->
             <mat-form-field appearance="outline" class="half-width">
                <mat-label>First Name</mat-label>
                <input matInput [(ngModel)]="userdata.firstName" name="firstName" required #firstName="ngModel">
                <mat-error *ngIf="firstName.invalid && firstName.touched">First name is required</mat-error>
              </mat-form-field>
            <!-- Last Name -->
            <mat-form-field appearance="outline" class="half-width">
              <mat-label>Last Name</mat-label>
              <input matInput [(ngModel)]="userdata.lastName" name="lastName" required #lastName="ngModel">
              <mat-error *ngIf="lastName.invalid && lastName.touched">Last name is required</mat-error>
            </mat-form-field>
  
           
          </div>
  
        
  
          <div class="form-row">

             <!-- Primary Phone -->
             <mat-form-field appearance="outline" class="half-width">
                <mat-label>Primary Phone</mat-label>
                <input matInput [(ngModel)]="userdata.primaryPhone" name="primaryPhone" [pattern]="phonePattern" #primaryPhone="ngModel">
                <mat-error *ngIf="primaryPhone.errors?.pattern && primaryPhone.touched">
                  Enter a valid phone number (e.g., +1 949 609 1497)
                </mat-error>
              </mat-form-field>
            <!-- Title -->
            <mat-form-field appearance="outline" class="half-width">
              <mat-label>Title</mat-label>
              <input matInput [(ngModel)]="userdata.title" name="title">
            </mat-form-field>
  
           
          </div>
         
          
          <div class="form-row">
 
             <!-- Notes (Will be alone at the bottom) -->
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Notes</mat-label>
            <textarea matInput [(ngModel)]="userdata.notes" name="notes"></textarea>
          </mat-form-field>
          
  
          </div>
          <!-- Table above Notes -->
          <table mat-table [dataSource]="userdata.organization" *ngIf="userdata.organization.length > 0">
            <ng-container matColumnDef="organization">
              <th mat-header-cell *matHeaderCellDef> Organization </th>
              <td mat-cell *matCellDef="let element">{{element.organizationName}}</td>
            </ng-container>
          
            <ng-container matColumnDef="role">
              <th mat-header-cell *matHeaderCellDef> User Type </th>
              <td mat-cell *matCellDef="let element">{{getRole(element.roleId)}}</td>
            </ng-container>
          
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef> Status </th>
              <td mat-cell *matCellDef="let element">{{getStatus(element.organizationStatus)}}</td>
            </ng-container>
          
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          
          <!-- No Data Message -->
          <div class="no-data-message" *ngIf="userdata.organization.length === 0">
            No organization assigned to you.
          </div>
          
        
        </div>
  
        <!-- Form Actions -->
        <div class="form-actions">
          <button mat-raised-button color="primary" (click)="updateUserProfile()" [disabled]="userForm.invalid">Update</button>
         
        </div>
      </form>
    </div>
  </div>
  